import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import "../../assets/styles/component/filters.scss";
import { FiltersLayout } from "../Layouts";

interface Props {
  filterBtns: Array<{ id: string; navigateTo: string; name: string }>;
}

// Thin nav-button row for the Online CE Performance family's own iframe pages (OCE Digital Trend)
// - mirrors GlobalMSSalesFilters.tsx exactly, kept as its own component rather than reused across
// families since each iframe-page family gets its own filter-bar wrapper in this codebase.
export const OnlineCeFilters = withRouter((props: Props & RouteComponentProps) => {
  const { filterBtns } = props;

  return (
    <FiltersLayout extraClass={"iframeFilters"} filterBtns={filterBtns}>
      <></>
    </FiltersLayout>
  );
});
